import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { ShipmentInfoPreparationTableComponent } from '../shipment-info-preparation-table/shipment-info-preparation-table.component';
import { ShipmentInfoPreparationViewModel } from '../shipment-info-preparation.model';

@Component({
  selector: 'app-shipment-info-ready',
  standalone: true,
  imports: [MatCard, ShipmentInfoPreparationTableComponent],
  templateUrl: './shipment-info-ready.component.html',
  styleUrl: './shipment-info-ready.component.scss',
})
export class ShipmentInfoReadyComponent {
  @Input({ required: true })
  public shipmentList: ShipmentInfoPreparationViewModel[] = [];

  @Output() public opened =
    new EventEmitter<ShipmentInfoPreparationViewModel>();
}
